export const en = {
    'normal-view-title': 'Add callouts to ads',
    'normal-view-title-hint': 'Shown because you have ads without callouts',
    'percent-value': '{value}%',
    'popup-view-title': 'Add callouts to the ad',
    'popup-view-title-hint': 'Shown because the ad has no callouts',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads',
    'title-extension-desc1': "Our research shows that callouts increase ads' CTR by {value}.",
    'title-extension-desc2':
        'You can use callouts to list the advantages of your products or services, announce special offers, or describe the benefits of working with your company.'
};
